export type AiChatHistoryItem = {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  pinned_at: string | null;
  access?: 'owner' | 'read';
  project_id?: string | null;
  folder_id?: string | null;
  /** 'field' = started in the field app (one thread per job). */
  channel?: 'web' | 'field';
};

export type AiChatHistoryGroup = {
  key: 'pinned' | 'today' | 'yesterday' | 'earlier';
  label: string;
  items: AiChatHistoryItem[];
};

export function applyPinnedAt<T extends { id: string; pinned_at: string | null }>(
  items: T[],
  chatId: string,
  pinnedAt: string | null,
): T[] {
  return items.map((item) => (item.id === chatId ? { ...item, pinned_at: pinnedAt } : item));
}

export function groupAiChats(
  chats: AiChatHistoryItem[],
  now: Date = new Date(),
): AiChatHistoryGroup[] {
  const pinned = chats
    .filter((chat) => chat.pinned_at)
    .slice()
    .sort((a, b) => String(b.pinned_at).localeCompare(String(a.pinned_at)));
  const rest = chats.filter((chat) => !chat.pinned_at);

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart.getTime() - 86400000);
  const today: AiChatHistoryItem[] = [];
  const yesterday: AiChatHistoryItem[] = [];
  const earlier: AiChatHistoryItem[] = [];

  for (const chat of rest) {
    const updated = new Date(chat.updated_at);
    const day = new Date(updated.getFullYear(), updated.getMonth(), updated.getDate());
    if (day >= todayStart) today.push(chat);
    else if (day >= yesterdayStart) yesterday.push(chat);
    else earlier.push(chat);
  }

  return [
    { key: 'pinned' as const, label: 'Angeheftet', items: pinned },
    { key: 'today' as const, label: 'Heute', items: today },
    { key: 'yesterday' as const, label: 'Gestern', items: yesterday },
    { key: 'earlier' as const, label: 'Früher', items: earlier },
  ].filter((group) => group.items.length > 0);
}
